import Layout from "@/layout/index.vue";

export default [
  // 渠道管理
  {
    path: "/qdgl",
    name: "qdgl",
    component: Layout,
    redirect: "/template-manage",
    meta: {
      title: "渠道管理",
    },
    children: [
      {
        path: "/template-manage",
        name: "templateManage",
        component: () => import("@/views/page/qdgl/template-manage/index.vue"),
        meta: {
          title: "模板配置",
          newPage: true,
          // noCache: true,
        },
      },
      // {
      //   path: "/template-manage2",
      //   name: "templateManage2",
      //   component: () => import("@/views/page/qdgl/templateManage/index.vue"),
      //   meta: {
      //     title: "模板配置(old)",
      //   },
      // },
      {
        path: "/channel-manage",
        name: "channelManage",
        component: () => import("@/views/page/qdgl/channelManage/index.vue"),
        meta: {
          title: "渠道配置",
        },
      },
      {
        path: "/links-manage",
        name: "linksManage",
        component: () => import("@/views/page/qdgl/linksManage/index.vue"),
        meta: {
          title: "链接管理",
          newPage: true,
        },
      },
      {
        path: "/filename-list",
        name: "filenameList",
        component: () => import("@/views/page/qdgl/filename-list/index.vue"),
        meta: {
          title: "文件名称",
          newPage: true,
        },
      },
      {
        path: "/resource-manage",
        name: "resourceManage",
        component: () => import("@/views/page/qdgl/resource-manage/index.vue"),
        meta: {
          title: "模板资源配置",
          newPage: true,
        },
      },
      {
        path: "/feedback-manage",
        name: "feedbackManage",
        component: () => import("@/views/page/qdgl/feedbackManage/index.vue"),
        meta: {
          title: "反馈配置",
        },
      },
      {
        path: "/payment-aisle-manage",
        name: "paymentAisleManage",
        component: () => import("@/views/page/qdgl/paymentAisleManage/index.vue"),
        meta: {
          title: "支付通道分配策略",
        },
      },
      {
        path: "/toufang-ab-manage",
        name: "toufangAbManage",
        component: () => import("@/views/page/qdgl/toufang-ab-manage/index.vue"),
        meta: {
          title: "投放AB分流配置",
        },
      },
      {
        path: "/qdgl/product-recommend",
        name: "qdglProductRecommend",
        component: () => import("@/views/page/qdgl/product-recommend/index.vue"),
        meta: {
          title: "推荐弹窗配置",
          newPage: true,
        },
      },
    ],
  },
  // 配置管理
  {
    path: "/config",
    name: "config",
    component: Layout,
    redirect: '/config/zx-city-config-list',
    meta: {
      title: "配置管理",
    },
    children: [
      {
        path: "/config/sdqw-qrcode",
        name: "configSdqwQrcode",
        component: () => import("@/views/config/pages/sdqw-qrcode/index.vue"),
        meta: {
          title: "公众号自动回复",
          newPage: true,
        },
      },
      {
        path: "/config/zx-city-config-list",
        name: "configZxCityConfigList",
        component: () => import("@/views/config/pages/zx-city-config-list/index.vue"),
        meta: {
          title: "赠险-城市配置",
          newPage: true,
        },
      },
      {
        path: "/config/inventory-config",
        name: "configInventoryConfig",
        component: () => import("@/views/mttf/pages/inventory-config/index.vue"),
        meta: {
          title: "赠险-库存配置",
          newPage: true,
        },
      },
      {
        path: "/config/zx-immediate-insure",
        name: "zxImmediateInsure",
        component: () => import("@/views/config/pages/zx-immediate-insure/index.vue"),
        meta: {
          title: "赠险-实时承保数据",
          newPage: true,
        },
      },
    ],
  },
  // 产品管理
  {
    path: "/product-manage",
    name: "productManage",
    component: Layout,
    redirect: "/product-manage/zx-rate",
    meta: {
      title: "产品管理",
    },
    children: [
      {
        path: "/product-manage/zx-rate",
        name: "productManageZxRate",
        component: () =>
          import("@/views/product-manage/pages/zx-rate/index.vue"),
        meta: {
          title: "赠险",
          newPage: true,
        },
      },
    ],
  },
  // 工具管理
  {
    path: "/tool",
    name: "tool",
    component: Layout,
    redirect: '/tool/ai-audio-validate',
    meta: {
      title: "工具管理",
    },
    children: [
      {
        path: "/tool/ai-voice-assign",
        name: "toolAiVoiceAssign",
        component: () => import("@/views/tool/pages/ai-voice-assign/index.vue"),
        meta: {
          title: "录音下发",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-audio-validate",
        name: "toolAiAudioValidate",
        component: () => import("@/views/tool/pages/ai-audio-validate/index.vue"),
        meta: {
          title: "AI音频验证",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-voice-mark",
        name: "toolAiVoiceMark",
        component: () => import("@/views/tool/pages/ai-voice-mark/index.vue"),
        meta: {
          title: "标记台",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-mark-call-record",
        name: "toolAiMarkCallRecord",
        component: () => import("@/views/tool/pages/ai-mark-call-record/index.vue"),
        meta: {
          title: "通话记录",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-voice-mark-list",
        name: "toolAiVoiceMarkList",
        component: () => import("@/views/tool/pages/ai-voice-mark-list/index.vue"),
        meta: {
          title: "对话观察台",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-faq-update",
        name: "toolAiFaqUpdate",
        component: () => import("@/views/tool/pages/ai-faq-update/index.vue"),
        meta: {
          title: "FAQ维护台",
          newPage: true,
        },
      },
      {
        path: "/tool/ai-test",
        name: "toolAiTest",
        component: () => import("@/views/tool/pages/ai-test/index.vue"),
        meta: {
          title: "测试台",
          newPage: true,
        },
      },
      {
        path: "/tool/tts-audio-create",
        name: "toolTtsAudioCreate",
        component: () => import("@/views/tool/pages/tts-audio-create/index"),
        meta: {
          title: "TTS音频生成",
          newPage: true,
        },
      },
      // {
      //   path: "/tool/ai-strate-iterate",
      //   name: "toolaiStrateIterate",
      //   component: () => import("@/views/tool/pages/ai-strate-iterate/index.vue"),
      //   meta: {
      //     title: "策略迭代",
      //     newPage: true,
      //   },
      // },
      {
        path: "/tool/ai-voice-mark-stats",
        name: "toolAiVoiceMarkStats",
        component: () => import("@/views/tool/pages/ai-voice-mark-stats/index.vue"),
        meta: {
          title: "数据看板",
          newPage: true,
        },
      },
    ],
  },
  // 用户管理
  {
    path: "/yhgl",
    name: "yhgl",
    component: Layout,
    redirect: "/menu",
    meta: {
      title: "用户管理",
    },
    children: [
      {
        path: "/menu",
        name: "userMenu",
        component: () => import("@/views/page/yhgl/MenuList.vue"),
        meta: {
          title: "菜单配置",
        },
      },
      {
        path: "/role",
        name: "userRole",
        component: () => import("@/views/page/yhgl/RoleList.vue"),
        meta: {
          title: "角色配置",
        },
      },
      {
        path: "/user",
        name: "userListOld",
        component: () => import("@/views/page/yhgl/UserList.vue"),
        meta: {
          title: "用户配置(旧)",
        },
      },
      {
        path: "/user/list",
        name: "userList",
        component: () => import("@/views/user/pages/list/index.vue"),
        meta: {
          title: "用户配置",
          newPage: true,
        },
      },
      {
        path: "/user/monitor-menu",
        name: "userMonitorMenu",
        component: () => import("@/views/user/pages/monitor-menu/index.vue"),
        meta: {
          title: "monitor-菜单配置",
          newPage: true,
        },
      },
      {
        path: "/user/monitor-report",
        name: "userMonitorReport",
        component: () => import("@/views/user/pages/monitor-report/index.vue"),
        meta: {
          title: "monitor-报表配置",
          newPage: true,
        },
      },
      {
        path: "/user/monitor-thead",
        name: "userMonitorThead",
        component: () => import("@/views/user/pages/monitor-thead/index.vue"),
        meta: {
          title: "monitor-表头配置",
          newPage: true,
        },
      },
      {
        path: "/user/monitor-role",
        name: "userMonitorRole",
        component: () => import("@/views/user/pages/monitor-role/index.vue"),
        meta: {
          title: "monitor-角色配置",
          newPage: true,
        },
      },
    ],
  },
]
